<b>Open Vehicle Defects</b>
<hr>
@if (loaded && defects.length === 0) {
  <p class="emptyState">No open defects right now.</p>
}
<ul class="defectList">
  @for (defect of defects; track defect) {
    <li>
      <strong>{{ defect.vehicle?.registration || ('Vehicle #' + defect.vehicleId) }}</strong>
      <span>{{ defect.description || 'No description provided' }}</span>
    </li>
  }
</ul>
